import React, { useState } from "react";
import {
  DocumentContainer,
  DocumentContent,
  DocumentFooter,
  DocumentHeader,
  DocumentHeaderLeft,
  DocumentHeaderRight,
  Title,
  Value, 
  ArchivedStatus
} from "./Document.styled";
import RenameVaultFileModal from "../RenameVaultFileModal/RenameVaultFileModal";
import ArchiveVaultFileModal from "../ArchiveVaultFileModal/ArchiveVaultFileModal";
import timeAgo from "../../../../../utils/timeAgo";
import { Icon } from '../../../../../elements';
import ShareVaultFileModal from '../ShareVaultFileModal/ShareVaultFileModal';
import MenuButtonWrapper from "../../../../../elements/v2/MenuButtonWrapper";

const Document = (props) => {
  
  const [isRenameModalOpen, setIsRenameModalOpen] = useState(false);
  const [isArchiveModalOpen, setIsArchiveModalOpen] = useState(false);
  const [showShareModal, setShowShareModal] = useState(false);

  const truncateFileName = (fileName) => {
    if (fileName.length <= 15) return fileName;
    return `${fileName.substring(0, 40)}...`;
  };

  const handleRename = (newName) => {
    setIsRenameModalOpen(false);
  };

  const handleArchive = () => {
    setIsArchiveModalOpen(false);
  };

  const handleContainerClick = (e) => {
    if (showShareModal) {
      e.preventDefault();
      e.stopPropagation();
      return;
    }

    if (e.target.closest('.menu-wrapper')) {
      e.preventDefault();
      e.stopPropagation();
      return;
    }

    props.onClick?.(props);
  };

  const handleCloseShareModal = () => {
    setShowShareModal(false);
  };

  const menuItems = [
    {
      label: 'Download',
      onClick: () => console.log('Download clicked')
    },
    {
      label: 'Rename',
      onClick: () => setIsRenameModalOpen(true)
    },
    {
      label: 'Duplicate',
      onClick: () => console.log('Duplicate clicked')
    },
    {
      label: 'Manage Access',
      onClick: () => console.log('Manage Access clicked')
    },
    {
      label: 'Share',
      onClick: () => setShowShareModal(true)
    },
    {
      label: 'Archive File',
      onClick: () => setIsArchiveModalOpen(true)
    },
    {
      label: 'View Activity Log',
      onClick: () => console.log('View Activity Log clicked')
    }
  ];

  if (!props) return null;

  return (
    <>
      <DocumentContainer 
        status={props.status}
        onClick={handleContainerClick}
        style={{ cursor: 'pointer' }}
        data-testid="document-container"
      >
        <DocumentHeader>
          <DocumentHeaderLeft title={props.name}>{truncateFileName(props.name)}</DocumentHeaderLeft>
          {props.status === 'archived' && (
            <ArchivedStatus>
              <Icon name="group" />
              Archived
            </ArchivedStatus>
          )}
          <DocumentHeaderRight>
            <div 
              className="menu-wrapper"
              onClick={(e) => {
                e?.preventDefault();
                e?.stopPropagation();
              }}
            >
              <MenuButtonWrapper items={menuItems} />
            </div>
          </DocumentHeaderRight>
        </DocumentHeader>
        <DocumentContent>{props.description}</DocumentContent>
        <DocumentFooter>
          <div>
            <Title>Size: </Title>
            <Value>{props.size} MB</Value>
          </div>
          <div>
            <Title>Last Updated: </Title>
            <Value>{props.last_modified ? timeAgo(props.last_modified) : '-'}</Value>
          </div>
        </DocumentFooter>
      </DocumentContainer>
      
      <RenameVaultFileModal
          data-testid="rename-vault-file-modal"
          isOpen={isRenameModalOpen}
          onClose={() => setIsRenameModalOpen(false)}
          onSubmit={handleRename}
          currentName={props?.name}
          fileId={props?.id}
          created_by={props?.created_by}
          status={props?.status}
        />  

      <ArchiveVaultFileModal
        data-testid="archive-vault-file-modal"
        isOpen={isArchiveModalOpen}
        onClose={() => setIsArchiveModalOpen(false)}
        onSubmit={handleArchive}
        name={props.name}
        fileId={props?.id}
        status={props.status}
      />

      <ShareVaultFileModal
        isOpen={showShareModal}
        onClose={handleCloseShareModal}
        fileId={props.id}
        vaultName={props.name}
        vaultId={props.folder_id}
      />

    </>
  );
};

export default Document;
